export * from './logo.component';
